import React from 'react'
import Icon from 'app/app/(client)/components/atoms/Icon/Icon'
import Input from 'app/app/(client)/components/atoms/Input/Input'
import { SIZES } from 'app/app/(client)/utils/client-constants'
import { sizes } from 'app/types/types'
import Tooltip from '../Tooltip/Tooltip'

interface Props {
  id: string
  searchQuery: string
  onSearchQueryChange: (val: string) => void
  placeHolder?: string
  maxQueryLength?: number
  minQueryLength?: number
  isDisabled?: boolean
  className?: string
  tooltipText?: string
}

const SearchBox: React.FC<Props> = ({
  id,
  searchQuery,
  onSearchQueryChange,
  placeHolder = 'Search',
  isDisabled = false,
  maxQueryLength = 20,
  minQueryLength = 0,
  className = '',
  tooltipText
}) => {
  const handleSearchQueryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value
    onSearchQueryChange(query)
  }

  const handleClearSearch = () => {
    onSearchQueryChange('')
  }

  const inputWithIcons = (
    <div className="w-full">
      <Input
        id={`search-box-${id}`}
        type="text"
        inputSize={SIZES.small as sizes}
        value={searchQuery}
        className={`input search-box pe-12 max-w-full! ${className}`}
        onChangeFn={handleSearchQueryChange}
        minLength={minQueryLength}
        maxLength={maxQueryLength}
        placeholder={placeHolder}
        disabled={isDisabled}
      />
      {/* Clear button - shown when there's an error */}
      {searchQuery && (
        <button
          type="button"
          onClick={handleClearSearch}
          className="flex absolute end-10 top-1/2 -translate-y-1/2 cursor-pointer pointer-events-auto z-10"
          aria-label="Clear search"
        >
          <Icon name="icon-close-circle-filled" className="text-[20px] text-black hover:text-grey-dark" />
        </button>
      )}
      {/* Search icon - always visible on the right */}
      <Icon
        name="icon-search"
        className="text-[20px] text-black absolute end-3 top-1/2 -translate-y-1/2 pointer-events-none"
      />
    </div>
  )

  return (
    <div id={`search-box-outer-div-${id}`} className="relative w-full">
      {tooltipText ? (
        <Tooltip id={`searchbox-tooltip-${id}`} content={tooltipText} position="top">
          {inputWithIcons}
        </Tooltip>
      ) : (
        inputWithIcons
      )}
    </div>
  )
}

export default SearchBox
